var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"tile":""}},[_vm._v(" IMAGE LIST ")])}
var staticRenderFns = []

export { render, staticRenderFns }